// Per-tab SIP session id. The gateway turns it into the extension
// admin-<user id>-<session id>, so every tab registers its own contact.
//
// sessionStorage (not localStorage) on purpose:
// - each tab gets its own id, so two tabs never share one SIP identity;
// - it survives a reload of the same tab, so FreeSWITCH sees the same
//   contact instead of a new stale registration per reload;
// - it does not change localStorage.length, which Header.js relies on.
// Caveat: the browser's "Duplicate tab" copies sessionStorage, so a
// duplicated tab starts with the same id.

const KEY = 'voice_session_id'
const VALID = /^[a-zA-Z0-9]{1,32}$/ // what the gateway accepts

let memoryId = null

function randomHex(bytes) {
  const cryptoObj = window.crypto || window.msCrypto
  if (cryptoObj && cryptoObj.getRandomValues) {
    const buf = new Uint8Array(bytes)
    cryptoObj.getRandomValues(buf)
    return Array.prototype.map
      .call(buf, b => (b < 16 ? '0' : '') + b.toString(16))
      .join('')
  }
  let out = ''
  while (out.length < bytes * 2) {
    out += Math.floor(Math.random() * 16).toString(16)
  }
  return out
}

export function getOrCreateSessionId() {
  let id = null
  try {
    id = window.sessionStorage.getItem(KEY)
  } catch (err) {
    // Storage blocked: keep an in-memory id for this page load.
  }
  if (id && VALID.test(id)) return id

  id = memoryId || randomHex(4)
  memoryId = id
  try {
    window.sessionStorage.setItem(KEY, id)
  } catch (err) {
    // Storage blocked: the in-memory id is still used.
  }
  return id
}
